import { ModalController } from "react-modal-global"

const Modal = new ModalController
export default Modal
